module.exports = __webpack_public_path__ + "static/media/2551079_lower.2ff0b132.jpg";